// RemarkFormModal — small centered modal for creating a new remark from a
// drag-created rect. Mirrors legacy stbarts (.modal-overlay + .modal block,
// index.html L1816-1826). Open via state.pendingRect (set in ContentView
// CaptureCell after a successful mousedown → mouseup drag). Save POSTs to
// /api/v1/remarks; cancel clears the pending rect.

import { Show, createSignal } from 'solid-js';
import { actions, stores } from '../state/store';

export function RemarkFormModal() {
  const [text, setText] = createSignal('');
  const [submitting, setSubmitting] = createSignal(false);
  const [error, setError] = createSignal<string | null>(null);

  function close() {
    setText('');
    setError(null);
    actions.setPendingRect(null);
  }

  async function save() {
    setError(null);
    const body = text().trim();
    if (!body) {
      setError('Texte requis');
      return;
    }
    const pending = stores.state.pendingRect;
    const author = stores.auth.email;
    if (!pending || !author) return;
    setSubmitting(true);
    try {
      await actions.createRemark({
        author,
        text: body,
        status: 'open',
        captureId: pending.captureId,
        variantId: pending.variantId,
        resolutionName: pending.resolutionName,
        targetSlug:
          stores.state.targets.find((t) => t.id === stores.state.activeTargetId)?.slug ?? '',
        rect: {
          x: Math.round(pending.x),
          y: Math.round(pending.y),
          width: Math.round(pending.width),
          height: Math.round(pending.height),
        },
      });
      close();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Création impossible');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Show when={stores.state.pendingRect}>
      <div class="modal-overlay" onClick={(e) => e.target === e.currentTarget && close()}>
        <div class="modal">
          <h3>Add Remark</h3>
          <label>Your remark</label>
          <textarea
            placeholder="Describe the issue or suggestion…"
            value={text()}
            onInput={(e) => setText(e.currentTarget.value)}
            disabled={submitting()}
          />
          <Show when={error()}>
            <p class="comments-error">{error()}</p>
          </Show>
          <div class="modal-buttons">
            <button type="button" class="btn-cancel" onClick={close}>
              Cancel
            </button>
            <button
              type="button"
              class="btn-save"
              onClick={() => void save()}
              disabled={submitting() || !text().trim()}
            >
              {submitting() ? 'Enregistrement…' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </Show>
  );
}
